import { usePendingBulkActionsPoller } from '@/hooks/usePendingBulkActionsPoller';

export const PendingBulkActionsPoller = () => {
  usePendingBulkActionsPoller();
  return null;
};
